import { render, staticRenderFns } from "./TheorySwitchHint.vue?vue&type=template&id=1a0b2a8e&scoped=true&"
import script from "./TheorySwitchHint.vue?vue&type=script&lang=js&"
export * from "./TheorySwitchHint.vue?vue&type=script&lang=js&"
import style0 from "./TheorySwitchHint.vue?vue&type=style&index=0&id=1a0b2a8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0b2a8e",
  null
  
)

export default component.exports